
import AppSaleDetailBrowse from "@/components/sales/SaleDetailBrowse.vue";
import { ToolbarService } from "@/services/toolbar-service";

import Vue from "vue";

export default Vue.extend({
	mounted() {
		ToolbarService.title = this.$ct("purchase-details");
	},
	components: {
		AppSaleDetailBrowse
	},
	i18nEx: {
		componentPrefix: "components.sales"
	}
});
